import React from "react";
import AntdTimeline, {TimelineProps} from "antd/lib/timeline";
import {withError} from '@fishx/tracker';

const Item = AntdTimeline.Item;
interface FCTimelineProps extends React.FC<TimelineProps> {
   Item: typeof Item;
}
export const Timeline: FCTimelineProps = (props) => {
  return <AntdTimeline {...props} />;
}
Timeline.Item = Item;
Timeline.displayName = 'Timeline';
export default withError(Timeline);



// WEBPACK FOOTER //
// ./src/components/timeline/index.tsx